var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataSource } from '@angular/cdk/table';
import { OnInit } from '@angular/core';
import { Observable } from 'rxjs';
var OrganisationsTableComponent = /** @class */ (function () {
    function OrganisationsTableComponent() {
    }
    OrganisationsTableComponent.prototype.ngOnInit = function () {
        this.displayedColumns = ['name', 'number', 'address'];
        this.dataSource = new OrganisationDataSource(this.organisations);
    };
    return OrganisationsTableComponent;
}());
export { OrganisationsTableComponent };
var OrganisationDataSource = /** @class */ (function (_super) {
    __extends(OrganisationDataSource, _super);
    function OrganisationDataSource(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    OrganisationDataSource.prototype.connect = function () {
        return this.data;
    };
    OrganisationDataSource.prototype.disconnect = function () {
        // lint
    };
    return OrganisationDataSource;
}(DataSource));
export { OrganisationDataSource };
